import React from 'react';

import { observer } from 'mobx-react';

import { useNavigate } from 'react-router-dom';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';

import { Button } from 'components/Button';

import routes from 'core/routes';

import { useNavBarHeight } from 'utils/hooks/navbar';

import AcknowledgementRequestsGrid from './components/AcknowledgementRequestsGrid';

const AcknowledgementRequests: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const navigate = useNavigate();

  const handleNewRequest = (): void => {
    navigate(routes.dashboard.documents.acknowledgementRequests.new.toString());
  };

  return (
    <Record
      navBarHeight={navBarHeight}
      Header={
        <MainHeader
          title="Acknowledgements"
          breadcrumbs={[
            { label: 'Documents', link: routes.dashboard.documents.toString() },
            {
              label: 'Acknowledgements',
              link: routes.dashboard.documents.acknowledgementRequests.toString(),
            },
          ]}
          action={
            <Button variant="contained" size="large" onClick={handleNewRequest}>
              + New request
            </Button>
          }
        />
      }
      Content={() => <AcknowledgementRequestsGrid />}
    />
  );
};

export default observer(AcknowledgementRequests);
